/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import BrandIcon from './BrandIcon';
import Button from '../elements/Button';

export default function Footer() {
  return (
    <div className="bg-gray-50 border-t border-gray-200 pb-6">
      <div className="container flex-col mx-auto ">
        <div className="flex flex-col sm:flex-row mt-8 justify-center">
          <div className="w-1/3 flex-col ml-16 mr-8">
            <BrandIcon />
            <p className="w-full text-lg text-gray-400 font-light">
              Your Trusted CNC
              {' '}
              <br />
              Service Partner
            </p>
          </div>
          <div className="w-1/3 mt-0 ml-16 mr-0 sm:ml-0 sm:mr-5">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">
              Office
            </h1>
            <p className="text-lg text-gray-400 font-light">
              oknumteknisi@gmail.com
            </p>
            <p className="text-lg text-gray-400 font-light">
              DKI Jakarta
            </p>
          </div>
          <div className="w-1/3 ml-16 sm:ml-0 mt-0">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">
              Social
            </h1>
            <p className="flex text-lg text-gray-400 font-light">
              Instagram
            </p>
            <p className="flex text-lg text-gray-400 font-light">
              LinkedIn
            </p>
            <p className="flex text-lg text-gray-400 font-light">
              Github
            </p>
          </div>
        </div>
        <div className="flex-col text-center mt-7">
          <p className="text-lg text-gray-400 font-light">
            Copyright 2026 - All rights reserved - Teknisi CNC
          </p>
          <div className="flex-row">
            <p className="inline-block text-lg text-gray-400 font-light">
              Made with &#x2764; by&nbsp;
            </p>
            <Button href="https://www.instagram.com/bayghf/" type="link" target="_blank" className="text-lg text-theme-purple font-light" isExternal>
              Bayu Abdul Ghofar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
